var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        "overlay-color": "grey darken-2",
        transition: "scroll-x-transition",
        "max-width": "700",
        "content-class": "overflowY-hidden",
        persistent: "",
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        { staticClass: "accent", attrs: { width: "700px" } },
        [
          _c(
            "v-card-title",
            {
              staticClass: "pageTitle",
              staticStyle: { "background-color": "#47bd96", color: "white" },
              style: _vm.$vuetify.breakpoint.xsOnly
                ? "text-align: center !important;"
                : "",
            },
            [_vm._v("New Chart")]
          ),
          _c(
            "v-stepper",
            {
              staticClass: "chart-wizard",
              attrs: { vertical: "", flat: "" },
              model: {
                value: _vm.step,
                callback: function ($$v) {
                  _vm.step = $$v
                },
                expression: "step",
              },
            },
            [
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 1, step: "1" } },
                [
                  _vm._v(" Name "),
                  _c("small", [_vm._v(_vm._s(_vm.newChart.name))]),
                ]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "1" } },
                [
                  _c("v-text-field", {
                    staticClass: "mt-2",
                    staticStyle: { width: "300px" },
                    attrs: { dense: "", outlined: "", label: "Chart Name" },
                    on: { keydown: _vm.keyPressed },
                    model: {
                      value: _vm.newChart.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.newChart, "name", $$v)
                      },
                      expression: "newChart.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-stepper-step",
                { attrs: { complete: _vm.step > 2, step: "2" } },
                [_vm._v(" Type ")]
              ),
              _c(
                "v-stepper-content",
                { attrs: { step: "2" } },
                [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { sm: "4", cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "", justify: "center" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  class: {
                                    "primary--text": _vm.isChart,
                                  },
                                  attrs: { "x-small": "" },
                                },
                                [_vm._v("fas fa-chart-line")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "text-center mb-0",
                                  class: {
                                    "primary--text": _vm.isChart,
                                  },
                                },
                                [_vm._v(" Chart ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", height: "120" },
                              on: {
                                click: function ($event) {
                                  _vm.newChart.type =
                                    _vm.VISUALIZATION_TYPES.CHART
                                },
                              },
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: require("../../assets/views-images/pricewatcher/chart.png"),
                                  "aspect-ratio": 18 / 9,
                                  width: "185",
                                },
                              }),
                              _vm.isChart
                                ? _c("i", {
                                    staticClass:
                                      "primary--text fas fa-check-circle",
                                    staticStyle: {
                                      position: "absolute",
                                      "font-size": "26px",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          class: { "pl-4": _vm.$vuetify.breakpoint.smAndUp },
                          attrs: { sm: "4", cols: "12" },
                        },
                        [
                          _c(
                            "v-row",
                            { attrs: { "no-gutters": "", justify: "center" } },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  class: {
                                    "primary--text":
                                      _vm.newChart.type ===
                                      _vm.VISUALIZATION_TYPES.LIVE_TABLE,
                                  },
                                  attrs: { "x-small": "" },
                                },
                                [_vm._v("fas fa-broadcast-tower")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "text-center mb-0",
                                  class: {
                                    "primary--text":
                                      _vm.newChart.type ===
                                      _vm.VISUALIZATION_TYPES.LIVE_TABLE,
                                  },
                                },
                                [_vm._v(" Live Table ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "px-2",
                              attrs: { text: "", height: "120" },
                              on: {
                                click: function ($event) {
                                  _vm.newChart.type =
                                    _vm.VISUALIZATION_TYPES.LIVE_TABLE
                                },
                              },
                            },
                            [
                              _c("v-img", {
                                attrs: {
                                  src: require("../../assets/views-images/pricewatcher/table_live.png"),
                                  "aspect-ratio": 18 / 9,
                                  width: "185",
                                },
                              }),
                              _vm.newChart.type ===
                              _vm.VISUALIZATION_TYPES.LIVE_TABLE
                                ? _c("i", {
                                    staticClass:
                                      "primary--text fas fa-check-circle",
                                    staticStyle: {
                                      position: "absolute",
                                      "font-size": "26px",
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { sm: "4", cols: "12" } },
                        [
                          _c(
                            "v-row",
                            {
                              staticStyle: { position: "relative" },
                              attrs: { "no-gutters": "", justify: "center" },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "mr-1",
                                  class: {
                                    "primary--text": _vm.isHistoricalTable,
                                  },
                                  attrs: { "x-small": "", color: "grey" },
                                },
                                [_vm._v("fa-solid fa-clock-rotate-left")]
                              ),
                              _c(
                                "p",
                                {
                                  staticClass: "text-center mb-0 grey--text",
                                  class: {
                                    "primary--text": _vm.isHistoricalTable,
                                  },
                                },
                                [_vm._v(" Historical Table ")]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { justify: "center" } },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "px-6",
                                  attrs: {
                                    disabled: "",
                                    text: "",
                                    height: "120",
                                    stle: "width:150px !important;",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.newChart.type =
                                        _vm.VISUALIZATION_TYPES.HISTORY_TABLE
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-row",
                                    { attrs: { justify: "center" } },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: require("../../assets/views-images/pricewatcher/table.png"),
                                          "aspect-ratio": 13 / 9,
                                          width: "140",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.isHistoricalTable
                                    ? _c("i", {
                                        staticClass:
                                          "primary--text fas fa-check-circle",
                                        staticStyle: {
                                          position: "absolute",
                                          "font-size": "26px",
                                        },
                                      })
                                    : _vm._e(),
                                  _c("v-overlay", {
                                    attrs: {
                                      disabled: "",
                                      absolute: true,
                                      value: true,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        complete: _vm.step > 3,
                        "error-icon": "fa-solid fa-circle-xmark",
                        step: "3",
                      },
                    },
                    [
                      _vm._v(
                        " Watcher" +
                          _vm._s(_vm.isHistoricalTable ? "" : "s") +
                          " "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.newChart.watchers.length
                              ? _vm.newChart.watchers.length
                              : ""
                          )
                        ),
                      ]),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "3" } },
                    [
                      _c("v-select", {
                        staticClass: "mt-2",
                        staticStyle: { width: "300px" },
                        attrs: {
                          dense: "",
                          outlined: "",
                          items: _vm.watchers,
                          "item-value": "id",
                          "item-text": "name",
                          multiple: "",
                          "menu-props": { offsetY: true, maxHeight: "250" },
                          label: "Watchers",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item",
                            fn: function ({ item }) {
                              return [
                                _c(
                                  "div",
                                  {
                                    class: {
                                      "grey--text": item.appStatus !== "RUN",
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(item.name) + " ")]
                                ),
                              ]
                            },
                          },
                          {
                            key: "selection",
                            fn: function ({ item, index }) {
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [_vm._v(_vm._s(item.name))]),
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c("span", [
                                      _vm._v(
                                        " (+" +
                                          _vm._s(
                                            _vm.newChart.watchers.length - 1
                                          ) +
                                          " others) "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "prepend-item",
                            fn: function () {
                              return [
                                _c(
                                  "v-list-item",
                                  {
                                    staticStyle: {
                                      "max-height": "40px",
                                      "border-bottom": "1px solid #7f7f7f",
                                    },
                                    attrs: { ripple: "" },
                                    on: { click: _vm.selectAllWatchers },
                                  },
                                  [
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          {
                                            class:
                                              _vm.newChart.watchers.length ===
                                              _vm.watchers.length
                                                ? "primary--text"
                                                : _vm.$vuetify.theme.dark
                                                ? "white--text"
                                                : "black--text",
                                            staticStyle: {
                                              "font-size": "16px !important",
                                              "font-weight": "400",
                                            },
                                          },
                                          [_vm._v("Select All")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.newChart.watchers,
                          callback: function ($$v) {
                            _vm.$set(_vm.newChart, "watchers", $$v)
                          },
                          expression: "newChart.watchers",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        step: "4",
                        "error-icon": "fa-solid fa-circle-xmark",
                      },
                    },
                    [_vm._v("Symbol ")]
                  ),
                ],
                1
              ),
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _c(
                    "v-stepper-content",
                    {
                      staticClass: "pl-3",
                      staticStyle: { "padding-right": "30px" },
                      attrs: { step: "4" },
                    },
                    [
                      _c("v-autocomplete", {
                        staticClass: "mt-2",
                        staticStyle: { width: "300px" },
                        attrs: {
                          items: _vm.symbols,
                          multiple:
                            _vm.newChart.type ===
                            _vm.VISUALIZATION_TYPES.LIVE_TABLE,
                          dense: "",
                          outlined: "",
                          label: "Symbol",
                          "no-data-text":
                            "No common symbols in selected watchers",
                          icon: "",
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "selection",
                            fn: function ({ item, index }) {
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [_vm._v(_vm._s(item))]),
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c("span", [
                                      _vm._v(
                                        " (+" +
                                          _vm._s(
                                            _vm.newChart.symbols.length - 1
                                          ) +
                                          " others) "
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "item",
                            fn: function ({ item, attrs }) {
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "font-size": "0.875rem" } },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "mr-1",
                                        attrs: {
                                          color: !attrs.inputValue
                                            ? "white"
                                            : "primary",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              attrs.inputValue
                                                ? "radio_button_checked"
                                                : "radio_button_unchecked"
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" " + _vm._s(item) + " "),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                        model: {
                          value: _vm.newChart.symbols,
                          callback: function ($$v) {
                            _vm.$set(_vm.newChart, "symbols", $$v)
                          },
                          expression: "newChart.symbols",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.isAdmin
                ? [
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        _c(
                          "v-stepper-step",
                          {
                            attrs: {
                              step: "5",
                              "error-icon": "fa-solid fa-circle-xmark",
                            },
                          },
                          [_vm._v("Visibility ")]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "transition",
                      { attrs: { name: "fade" } },
                      [
                        _c(
                          "v-stepper-content",
                          {
                            staticClass: "pl-3",
                            staticStyle: { "padding-right": "30px" },
                            attrs: { step: "5" },
                          },
                          [
                            _c(
                              "input-wrapper",
                              [
                                _c("v-switch", {
                                  attrs: {
                                    label: `${
                                      _vm.newChart.isPublic
                                        ? "Public"
                                        : "Private"
                                    }`,
                                    "hide-details": "",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.newChart.isPublic,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newChart, "isPublic", $$v)
                                    },
                                    expression: "newChart.isPublic",
                                  },
                                }),
                                _c(
                                  "v-tooltip",
                                  {
                                    attrs: { bottom: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  { attrs: { small: "" } },
                                                  on
                                                ),
                                                [_vm._v("fa fa-info-circle")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2313606731
                                    ),
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(
                                        "Specify if the chart will also be visible to regular users or only to Admin and to the owner of the chart"
                                      ),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "v-row",
            { staticClass: "mx-0 accent", attrs: { justify: "space-between" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "ma-2 opacity-1-slow",
                  attrs: { text: "" },
                  on: {
                    click: function ($event) {
                      _vm.dialog = false
                    },
                  },
                },
                [_vm._v("Cancel ")]
              ),
              _c(
                "v-btn",
                {
                  staticClass: "my-2 opacity-1-slow",
                  attrs: { disabled: _vm.step === 1, text: "" },
                  on: {
                    click: function ($event) {
                      _vm.step--
                    },
                  },
                },
                [_vm._v(" Back ")]
              ),
              _c("v-spacer"),
              _vm.showCreateBtn
                ? _c(
                    "v-btn",
                    {
                      staticClass: "ma-2",
                      attrs: { color: "primary" },
                      on: { click: _vm.createNew },
                    },
                    [_vm._v("Create ")]
                  )
                : _c(
                    "div",
                    { on: { click: _vm.continueWizard } },
                    [
                      _c(
                        "v-btn",
                        { staticClass: "ma-2", attrs: { color: "primary" } },
                        [_vm._v("Continue")]
                      ),
                    ],
                    1
                  ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }